import { useRouter } from "next/router";
import { useTranslation } from "../../core/translation.core";
import OutlineBtn from "../form/outlineBtn.comp";

interface BatchSelectionToolbarProps {
  selectedProductIds: Set<string>;
  setSelectedProductIds: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export default function BatchSelectionToolbar({ selectedProductIds, setSelectedProductIds }: BatchSelectionToolbarProps) {
  const router = useRouter();
  const { t, msg } = useTranslation();
  const count = selectedProductIds.size;

  if (count === 0) return null;

  function handleBatchEdit() {
    const ids = Array.from(selectedProductIds).join(",");
    router.push(`/product/batch-edit?ids=${ids}`);
  }

  function handleClearSelection() {
    setSelectedProductIds(new Set());
  }

  return (
    <div
      id="batch-edit-toolbar"
      className="flex gap-4 items-center px-4 bg-white dark:bg-her-darkSectionBg shadow-sm py-2 mb-6 rounded-2xl dark:text-slate-300"
    >
      <div className="flex items-center gap-2">
        <span id="batch-count" className="text-sm font-medium dark:text-white">
          {count} {count === 1 ? t(msg.product.product) : t(msg.product.products)} {t(msg.general.selected)}
        </span>
      </div>
      <OutlineBtn id="batch-edit-button" onClick={handleBatchEdit}>
        {t(msg.product.batchEdit)}
      </OutlineBtn>
      <button
        type="button"
        onClick={handleClearSelection}
        className="text-white bg-gray-500 hover:bg-gray-600 px-3 py-1 rounded-md"
      >
        {t(msg.form.cancel)}
      </button>
    </div>
  );
}
